<template functional>
    <span
        class="button-group | inline-flex"
        :class="[fullheight ? 'h-full' : 'rounded shadow-md', data.class, data.staticClass]"
    >
        <slot />
    </span>
</template>

<script>
    export default {
        props: {
            fullheight: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<style>
    .button-group > button {
        @apply rounded-none shadow-none;
    }

    .button-group.h-full > button {
        @apply -mx-1;
    }

    .button-group.h-full > button:hover {
        @apply z-10;
    }

    .button-group:not(.h-full) > button:first-child {
        @apply rounded-l;
    }

    .button-group:not(.h-full) > button:last-child {
        @apply rounded-r;
    }

    .button-group.rounded-t-none:not(.h-full) > button {
        @apply rounded-t-none !important;
    }
</style>
